import React, {useEffect} from 'react'
import {Stack} from '@mui/material'
import {colors} from '@/constants'
import {useNavigate} from 'react-router-dom'
import TransCustom from '@/components/UI/i18next'
import ProgressiveImage from '@/components/ProgressiveImage'

const Index = () => {
  const navigate = useNavigate()
  const breakpoint = 768

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth

      if (width > breakpoint) {
        navigate('/')
      }
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [navigate])

  return (
    <Stack
      id="main"
      direction="column"
      height="100%"
      style={{
        backgroundColor: '#191009',
      }}
      width="100%"
      alignItems="center"
      justifyContent="center"
      boxSizing="border-box">
      <ProgressiveImage
        lowSrc="images/gameBg/bg-low.jpg"
        highSrc="images/gameBg/bg.jpg"
        highSources={[
          {srcSet: 'images/gameBg/bg.avif', type: 'image/avif'},
          {srcSet: 'images/gameBg/bg.webp', type: 'image/webp'},
        ]}
        lowSources={[
          {srcSet: 'images/gameBg/bg-low.avif', type: 'image/avif'},
          {srcSet: 'images/gameBg/bg-low.webp', type: 'image/webp'},
        ]}
        width="1920"
        height="1200"
        wrapStyle={{
          flex: 1,
          display: 'grid',
          placeItems: 'center',
          width: '100%',
        }}
        imageStyle={{
          position: 'absolute',
          inset: '50%',
          transform: 'translate(-50%, -50%)',
          height: '100%',
          width: 'auto',
        }}>
        <Stack
          sx={{position: 'absolute', zIndex: 1}}
          gap="40px"
          textAlign="center">
          <TransCustom i18nKey="1429" variant="h1" color={colors.white} />
          <TransCustom i18nKey="1430" variant="button" color={colors.white} />
        </Stack>
      </ProgressiveImage>
    </Stack>
  )
}

export default Index
